import React from 'react'
import { Helmet } from 'react-helmet';
import Hero from '../components/Hero'
import banner from '../assets/contactbanner.png'
import ContactMapForm from './../components/ContactMapForm';
import OurWorks from './../components/OurWorks';
import { useNavigate } from 'react-router-dom';

const Contact = () => {

  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/service');
  };


  return (
    <div>
      <Helmet>
        <link rel="canonical" href="https://driveincarspa.com/contact" />
        <title>Car Spa Bangalore Contact | Nearby Car Detailing Services | Drive-in Car Spa</title>
        <meta name="description" content="Find and contact the best car spa in Bangalore. Book interior and exterior car detailing services with trusted professionals near you." />
        <meta name="keywords" content="car wash touchless machine, 360 automatic car wash machine, Auto detailing service contact Bangalore, Book car detailing service Bangalore , Car Spa Contact in Bangalore
" />
        <meta name="author" content="DriveIn Team" />
      </Helmet>
       <Hero
      title={
  <>
    <span className="highlight">Contact Drive-In Car Spa – We're Here </span><br />
    When Your Car Needs Attention –{" "}
  Car Spa Contact in Bangalore</>
 
}
        bgImage={banner}
         onButtonClick={handleServicesClick}
        buttonText='Services'
      />
      <ContactMapForm/>
      <OurWorks/>
    </div>
  )
}

export default Contact
